import type { FC } from 'react';
import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'next-i18next';
import type { BaseQueryPopupParams } from '@mwl/core-lib';
import { selectUserCurrency, useQueryPopupOpen } from '@mwl/core-lib';
import WalletPayoutIcon from '@public/assets/casino/icons/walletPayout.svg';
import type { ButtonProps } from '@/components/Button/Button.types';
import { ModalMessage } from '@/components/ModalMessage/ModalMessage';
import { useTypedSelector } from '@/hooks';
import { getLanguageDirection } from '@/utils';
import { useGameGoBack } from '../../CasinoGamePage.hooks';
import type { PopupBalanceNotEnoughMoneyProps } from './PopupBalanceNotEnoughMoney.types';
import styles from './PopupBalanceNotEnoughMoney.module.scss';
const popupClasses = {
  wrapper: styles.wrapper
};
export const PopupBalanceNotEnoughMoneyBase: FC<PopupBalanceNotEnoughMoneyProps> = ({
  game,
  defaultIsShow
}) => {
  const {
    t,
    i18n
  } = useTranslation('common');
  const langDirection = getLanguageDirection(i18n);
  const currency = useTypedSelector(selectUserCurrency);
  const [show, setShow] = useState(false);
  const {
    createLinkProps
  } = useQueryPopupOpen();
  const back = useGameGoBack(game);
  const handleClose = useCallback(() => {
    setShow(false);
    back();
  }, [back]);
  useEffect(() => {
    setShow(defaultIsShow);
  }, [defaultIsShow]);
  const linkProps = useMemo<ButtonProps>(() => ({
    ...createLinkProps({
      queryName: ('deposit' as BaseQueryPopupParams)
    }),
    replace: true,
    as: 'link'
  }), [createLinkProps]);
  const handleDeposit = useCallback(() => {
    setShow(false);
  }, []);
  return <ModalMessage show={show} onClose={handleClose} title={t('modal_message.not_enough_money', 'Not enough money on balance')} buttonText={t('modal_message.deposit', 'Deposit')} icon={<WalletPayoutIcon className={styles.icon} />} popupClasses={popupClasses} buttonProps={linkProps} onClick={handleDeposit} content={<div className={cn({
    [styles.balanceWrapperRight]: langDirection === 'rtl'
  })}>
          {t('modal_message.minimum_bet_per_game', 'The minimum bet for the selected game:')}{' '}
          <span className={styles.balance}>
            {game?.minBet || game?.minBalance} {currency}
          </span>
        </div>} data-sentry-element="ModalMessage" data-sentry-component="PopupBalanceNotEnoughMoneyBase" data-sentry-source-file="PopupBalanceNotEnoughMoney.tsx" />;
};
export const PopupBalanceNotEnoughMoney = memo(PopupBalanceNotEnoughMoneyBase);
PopupBalanceNotEnoughMoney.displayName = 'PopupBalanceNotEnoughMoney';